<template>
  <unicom-modal
    v-model="mostrar"
    :largura="616"
    fechar
    @input="valor => fecharModal(valor)"
  >
    <div slot="header" class="pb-2">
      <div class="titulo negrito cor-fonte fonte-primaria">
        Descrição do arquivo
      </div>
    </div>
    <div slot="body">
      <unicom-area-texto
        lang="pt"
        ref="area-edicao"
        :textAreaStyleProp="{
          'font-size': '16px',
          'line-height': '18px',
          padding: '14px 16px',
          'max-height': '100px'
        }"
        max="500"
        mostrarContador
        alturaAutomatica
        placeholder="Insira a descrição do arquivo..."
        v-model="observacaoData"
        @input="testForGrammarErrors"
        :disabled="!editar"
        :spellcheck="true"
      />
    </div>
    <div slot="footer">
      <unicom-linha justificarItem="end">
        <unicom-coluna
          sm="12"
          md="auto"
          class="margem-botao"
          :order="$breakpoint.smAndDown ? 1 : 0"
        >
          <unicom-botao
            class="fonte-secundaria texto"
            @click="$emit('input', false)"
            :altura="40"
            contornado
            :largura="172"
            :bloco="$breakpoint.smAndDown"
          >
            Cancelar
          </unicom-botao>
        </unicom-coluna>
        <unicom-coluna sm="12" md="auto" class="pb-2 margem-botao">
          <unicom-botao
            v-if="editar"
            class="fonte-secundaria texto"
            @click="salvar"
            :altura="40"
            :largura="172"
            :bloco="$breakpoint.smAndDown"
            :desabilitado="botaoEstaDesabilitado"
          >
            Salvar
          </unicom-botao>
        </unicom-coluna>
      </unicom-linha>
    </div>
  </unicom-modal>
</template>

<script>
import CorretorOrtografico from "../../../../../../../shared/mixin/CorretorOrtografico";

export default {
  mixins: [CorretorOrtografico],
  props: {
    value: {
      type: Boolean,
      required: true
    },
    observacao: {
      type: String,
      default: ""
    },
    editarSalvar: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      observacaoData: this.observacao,
      mostrar: this.value,
      editar: this.editarSalvar
    };
  },
  computed: {
    botaoEstaDesabilitado() {
      return this.observacaoData.trim() === ""; // Verifica se está vazio ou contém apenas espaços
    }
  },
  methods: {
    fecharModal(valor) {
      console.log("entrou no metodo fecha com o valor: ", valor);
      if (!valor) {
        console.log("entrou no if do metodo fecha com o valor: ", valor);
        this.limparModal();
        this.$emit("input", false);
      }
    },
    testForGrammarErrors() {
      if (!this.observacaoData) return;

      console.log(this.hasGrammarErrors(this.observacaoData));
    },
    salvar() {
      this.$emit("salvar-modal", this.observacaoData);
      this.fecharModal();
    },
    limparModal() {
      this.observacaoData = this.observacao;
    }
  },
  watch: {
    value() {
      this.mostrar = this.value;
      this.$emit("input", this.mostrar);
    },
    observacao() {
      this.observacaoData = this.observacao;
    },
    editarSalvar() {
      this.editar = this.editarSalvar;
      this.$emit("editar-modal", this.editar);
    }
  }
};
</script>

<style lang="scss" scoped>
.corpo-campo {
  min-height: 282px;
}
.margem-botao {
  padding-top: 20px;
  padding-bottom: 0px;
}
</style>
